import styled, { keyframes } from 'styled-components'
import { tokens } from 'styling/tokens'
import { IOpsBacklogBucket } from 'types/operationsControl.interface'

export const BoardColumns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-top: 1rem;
  @media (max-width: 70rem) {
    flex-direction: column;
  }
`

export const QueueColumn = styled.div`
  width: 62%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  @media (max-width: 70rem) {
    width: 100%;
  }
`

export const SideColumn = styled.div`
  width: 38%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (max-width: 70rem) {
    width: 100%;
  }
`

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const FilterLabel = styled.span`
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const TaskCard = styled.div<{ $blocked?: boolean }>`
  width: 100%;
  border-radius: ${tokens.radius.card};
  border: 1px solid ${({ $blocked }) => ($blocked ? tokens.status.danger.fg : tokens.border.hairline)};
  background: ${({ $blocked }) => ($blocked ? tokens.status.danger.bg : tokens.surface.glass)};
  backdrop-filter: blur(${tokens.blur});
  box-shadow: ${tokens.shadow.card};
  overflow: hidden;
`

export const TaskCardHead = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  color: ${tokens.text.primary};
`

export const TaskTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;
  flex: 1;
`

export const TaskTopRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const TaskName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.primary};
`

export const TaskMeta = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const ChevronWrap = styled.span<{ $open?: boolean }>`
  display: flex;
  align-items: center;
  color: ${tokens.text.muted};
  transition: color ${tokens.motion.duration} ${tokens.motion.ease};
  ${({ $open }) => $open && `color: ${tokens.accent.base};`}
`

export const UnassignedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  width: max-content;
  padding: 0.25rem 0.5rem;
  border-radius: ${tokens.radius.chip};
  font-size: ${tokens.font.micro};
  font-weight: 700;
  color: ${tokens.status.warning.fg};
  background: ${tokens.status.warning.bg};
`

export const BlockedReasonText = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.status.danger.fg};
`

export const TaskBody = styled.div`
  padding: 0.75rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-top: 1px solid ${tokens.border.hairline};
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem 1rem;
`

export const DetailCell = styled.div`
  min-width: 0;
`

export const DetailLabel = styled.span`
  display: block;
  margin-bottom: 0.25rem;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${tokens.text.muted};
`

export const DetailValue = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
`

export const ActionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const EmptyWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem 1rem;
  border-radius: ${tokens.radius.card};
  border: 1px dashed ${tokens.border.strong};
  background: ${tokens.surface.inset};
`

export const CountsLine = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
`

export const CountValue = styled.span<{ $danger?: boolean }>`
  font-weight: 700;
  color: ${({ $danger }) => ($danger ? tokens.status.danger.fg : tokens.text.primary)};
`

export const PanelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const RowMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const RowTitle = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const RowMuted = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const RowSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.375rem;
`

export const RowValue = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
  white-space: nowrap;
`

export const PartStock = styled.span<{ $danger?: boolean }>`
  font-size: ${tokens.font.label};
  font-weight: 600;
  white-space: nowrap;
  color: ${({ $danger }) => ($danger ? tokens.status.danger.fg : tokens.text.secondary)};
`

const gapPulse = keyframes`
  0% {
    opacity: 1;
    box-shadow: 0 0 0 0 ${tokens.status.danger.bg};
  }
  70% {
    opacity: 0.75;
    box-shadow: 0 0 0 0.5rem transparent;
  }
  100% {
    opacity: 1;
    box-shadow: 0 0 0 0 transparent;
  }
`

export const GapPill = styled.span`
  display: inline-flex;
  align-items: center;
  width: max-content;
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  font-size: ${tokens.font.micro};
  font-weight: 700;
  letter-spacing: 0.04em;
  color: ${tokens.status.danger.fg};
  background: ${tokens.status.danger.bg};
  border: 1px solid ${tokens.status.danger.fg};
  animation: ${gapPulse} 2s ${tokens.motion.ease} infinite;
`

export const IncidentsNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${tokens.border.hairline};
`

export const PlanRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const PlanHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`

export const PlanValue = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`

export const RiskRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const RiskChain = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`

export const RiskRecommendation = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const FuelAlertText = styled.span`
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.status.warning.fg};
`

export const FuelOkText = styled.span`
  display: block;
  padding: 0.5rem 0;
  font-size: ${tokens.font.label};
  color: ${tokens.status.success.fg};
  opacity: 0.8;
`

export const FuelSuffix = styled.span`
  margin-left: 0.375rem;
  font-size: ${tokens.font.micro};
  font-weight: 500;
  color: ${tokens.text.muted};
`

export const BucketLabel = styled.span<{ $danger?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $danger }) => ($danger ? 700 : 600)};
  color: ${({ $danger }) => ($danger ? tokens.status.danger.fg : tokens.text.primary)};
`

export const BucketCount = styled.span<{ $tone: IOpsBacklogBucket['tone'] }>`
  font-size: ${tokens.font.body};
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ $tone }) => tokens.status[$tone].fg};
`

export const ComplianceValue = styled.span<{ $warning?: boolean }>`
  font-size: ${tokens.font.label};
  font-weight: 600;
  white-space: nowrap;
  color: ${({ $warning }) => ($warning ? tokens.status.warning.fg : tokens.status.success.fg)};
`

export const PanelCaption = styled.span`
  display: block;
  margin-top: 0.5rem;
  font-size: ${tokens.font.label};
  font-style: italic;
  color: ${tokens.text.muted};
`

export const PanelFootnote = styled.span`
  display: block;
  margin-top: 0.5rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`
